export default __webpack_public_path__ + "static/media/KlipVidTwo.be47c288.png";